import type { InventoryItem } from './types';

export const INVENTORY_CATALOG: Record<string, InventoryItem> = {
  glyph_a: {
    id: 'glyph_a',
    label: 'Glyph A',
    icon: 'clock',
    description: 'A clock glyph — symbol of time measured.',
  },
  glyph_b: {
    id: 'glyph_b',
    label: 'Glyph B',
    icon: 'book-open',
    description: 'A journal glyph — symbol of experience recorded.',
  },
  glyph_c: {
    id: 'glyph_c',
    label: 'Glyph C',
    icon: 'note-sticky',
    description: 'A deadline glyph — symbol of time imposed.',
  },
  frame_key: {
    id: 'frame_key',
    label: 'Frame Key',
    icon: 'key',
    description: 'A key that unlocks the final archive. Given to those who question.',
  },
  sigil_complete: {
    id: 'sigil_complete',
    label: 'The Sigil',
    icon: 'star-of-david',
    description: 'The assembled sigil — proof that the frame was seen.',
  },
};
